import React from "react";
import "./DownloadActionButton.css";

interface DownloadActionButtonProps {
  label: string;
  onClick: () => void;
  loading?: boolean;
  id?: string;
}

const DownloadIcon: React.FC = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.40992 8.46089L11.0804 5.68103L10.3461 5.11532L7.92849 6.94682V0.150391H6.89135V6.94682L4.47481 5.1161L3.73947 5.68103L7.40992 8.46089ZM12.9939 11.1504C13.4717 11.1504 13.8703 11.0294 14.1897 10.7874C14.5092 10.5454 14.6692 10.2432 14.6699 9.88068V7.97689H13.6328V9.88068C13.6328 10.0017 13.5664 10.1127 13.4336 10.2138C13.3009 10.3149 13.1547 10.3652 12.9949 10.3647H1.82491C1.66588 10.3647 1.51964 10.3144 1.3862 10.2138C1.25275 10.1132 1.18637 10.0022 1.18706 9.88068V7.97689H0.149921V9.88068C0.149921 10.2426 0.309642 10.5446 0.629082 10.7866C0.948522 11.0286 1.34748 11.1499 1.82594 11.1504H12.9939Z"
      fill="#0A9281"
      stroke="#0A9281"
      strokeWidth="0.3"
    />
  </svg>
);

const DownloadActionButton: React.FC<DownloadActionButtonProps> = ({ label, onClick, loading = false, id }) => {
  return (
    <button
      id={id}
      type="button"
      className="download-action-button"
      onClick={onClick}
      disabled={loading}
    >
      <DownloadIcon />
      <span>{label}</span>
    </button>
  );
};

export default DownloadActionButton;
